import { createFileRoute, useParams } from '@tanstack/react-router';

import { AttendanceTab } from '@/views/admin/courses/tabs/attendance-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/attendance')({
  component: AttendanceRoute,
});

function AttendanceRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/attendance' });
  return <AttendanceTab id={id} />;
}
